(function galleryTab(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState || !global.NewHomeSource.TrackerMedia) {
    return;
  }

  const previousGalleryTab = global.NewHomeSource.GalleryTab;
  const trackerMedia = global.NewHomeSource.TrackerMedia;
  const queryNavigator = '[data-component="full-image-viewer-navigation"]';
  const queryArrowLeft = '[data-component="arrow-left"]';
  const queryArrowRight = '[data-component="arrow-right"]';
  const tabActiveClass = 'tab--active';
  const blockStyle = 'block';
  const none = 'none';
  const galleryNavigation = global.document.querySelector(queryNavigator + ' div');
  const leftGalleryArrow = global.document.querySelector(queryArrowLeft);
  const rightGalleryArrow = global.document.querySelector(queryArrowRight);
  const navCallToAction = global.document.querySelector('[data-component="data-nav-call-to-action"]');
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();
  const swipingObject = {};
  let navCallToActionLeftLimit = 0;
  let selectedCollection = null;

  if (!galleryNavigation || galleryNavigation.querySelectorAll('li').length === 0 ||
    !global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  /**
  * @private
  * isElementInsideViewport: returns true if a given collection is inside the viewport
  * @param {object} elementToCheck HTML element to check
  */
  function isElementInsideViewport(elementToCheck) {
    return elementToCheck.getBoundingClientRect().right <= navCallToActionLeftLimit;
  }

  /**
  * @private
  * getRightViewportLimit: gets the last limit in the nav bar where collection tabs are visible
  */
  function getRightViewportLimit() {
    navCallToActionLeftLimit = navCallToAction.getBoundingClientRect().left;
  }

  navCallToActionLeftLimit = requestAnimationFrame(getRightViewportLimit);

  /**
  * @private
  * isSelected: returs the value of the IsSelected property.
  *
  * @param {object} element that is being evaluated.
  */
  function isSelected(element) {
    return element.IsSelected;
  }

  /**
  * @private
  * isSelectedTabInsideViewport: returns true if the selected collection is inside the viewport, false if not
  */
  function isSelectedTabInsideViewport() {
    const state = global.NewHomeSource.FullImageViewerState.get();
    const selectedIndex = state.images.findIndex(isSelected);
    selectedCollection = galleryNavigation.querySelector('li [data-collection="' +
      state.images[selectedIndex].Collection + '"]');
    const rightLimitOfElement = selectedCollection.getBoundingClientRect().right;

    return rightLimitOfElement <= navCallToActionLeftLimit;
  }

  /**
  * @private
  * selectActiveTab: Changes the FIV state by selecting a new image
  * @param {event} event the event that fired this callback.
  */
  function selectActiveTab(event) {
    const state = global.NewHomeSource.FullImageViewerState.get();

    const getImageFromCollection = function getImageFromCollection(image) {
      return image.Collection === event.target.dataset.collection;
    };

    const imagesArray = Array.from(state.images);
    const newSelectedImage = imagesArray.filter(getImageFromCollection)[0];
    const newIndex = imagesArray.indexOf(newSelectedImage);

    global.NewHomeSource.FullImageViewerState.setImage(state.images[newIndex]);
  }

  /**
  * @private
  * showLeftAndRightArrow: shows/hides the left/right arrows of the nav bar
  */
  function showLeftAndRightArrow() {
    const firstCollection = galleryNavigation.querySelector('li');
    const lastCollection = galleryNavigation.querySelector('ul li:last-child');
    const leftNavigationLimit = 24;

    if (firstCollection.getBoundingClientRect().left < leftNavigationLimit) {
      leftGalleryArrow.style.display = blockStyle;
    } else {
      leftGalleryArrow.style.display = none;
    }

    if (lastCollection.getBoundingClientRect().right > navCallToActionLeftLimit) {
      rightGalleryArrow.style.display = blockStyle;
    } else {
      rightGalleryArrow.style.display = none;
    }
  }

  /**
  * @private
  * leftArrowClick: defines the function for the left gallery tab arrow.
  */
  function leftArrowClick() {
    galleryNavigation.scrollBy(-100, 0);
    requestAnimationFrame(showLeftAndRightArrow);
  }

  /**
   * @private
   * rightArrowClick: defines the function for the right gallery tab arrow.
   */
  function rightArrowClick() {
    galleryNavigation.scrollBy(100, 0);
    requestAnimationFrame(showLeftAndRightArrow);
  }

  /**
  * @private
  * touchCancel: resets the values of the swipingObject to their defaults
  */
  function touchCancel() {
    swipingObject.fingerCount = 0;
    swipingObject.startX = 0;
    swipingObject.startY = 0;
    swipingObject.curX = 0;
    swipingObject.curY = 0;
  }

  /**
  * @private
  * handleSwipeStart: handles the first values captured from the fingers gesture in the nav bar
  * @param {event} event the event of the fingers gesture (touchestart).
  */
  function handleSwipeStart(event) {
    swipingObject.fingerCount = event.touches.length;
    if (swipingObject.fingerCount === 1) {
      swipingObject.startX = event.touches[0].pageX;
      swipingObject.startY = event.touches[0].pageY;
    } else {
      touchCancel();
    }
  }

  /**
  * @private
  * handleSwipeEnd: handles the last values captured from the fingers gesture in the nav bar
  */
  function handleSwipeEnd() {
    if (swipingObject.fingerCount === 1 && swipingObject.curX !== 0) {
      requestAnimationFrame(showLeftAndRightArrow);
      touchCancel();
    } else {
      touchCancel();
    }
  }

  /**
  * @private
  * handleSwipeMove: handles the last values captured from the fingers gesture in the nav bar
  * @param {event} event the event of the fingers gesture (touchemove).
  */
  function handleSwipeMove(event) {
    if (event.touches.length === 1) {
      swipingObject.curX = event.touches[0].pageX;
      swipingObject.curY = event.touches[0].pageY;
    } else {
      touchCancel();
    }
  }

  /**
  * @private
  * setUpGalleryNavigationBar: sets up the navigation bar. It's call in a given
  * animation frame for it's use of getBoundingClientRect.
  * @param {object} data current state of the full image viewer.
  */
  function setUpGalleryNavigationBar(data) {
    let isActiveCollectionInsideViewport;
    const currentActiveCollection = galleryNavigation.querySelector('.' + tabActiveClass);
    if (currentActiveCollection) {
      currentActiveCollection.classList.remove(tabActiveClass);
    }
    getRightViewportLimit();
    if (data.Images) {
      isActiveCollectionInsideViewport = isSelectedTabInsideViewport(data);
    } else {
      isActiveCollectionInsideViewport = isElementInsideViewport(selectedCollection);
    }
    selectedCollection.classList.add(tabActiveClass);

    if (!isActiveCollectionInsideViewport) {
      galleryNavigation.scroll(selectedCollection.getBoundingClientRect().left, 0);
    }

    showLeftAndRightArrow();
  }

  /**
   * @public
   * render: renders the nav bar interactios.
   * @param {object} data current state of the full image viewer.
   */
  function render(data) {
    requestAnimationFrame(setUpGalleryNavigationBar.bind(this, data));
  }

  const eventsConfiguration = {
    letfArrow: {
      callbacks: [leftArrowClick],
      events: [eventToAttach],
      elements: queryArrowLeft,
    },
    rightArrow: {
      callbacks: [rightArrowClick],
      events: [eventToAttach],
      elements: queryArrowRight,
    },
    swipingStart: {
      callbacks: [handleSwipeStart],
      events: ['touchstart'],
      elements: queryNavigator,
    },
    swipingEnd: {
      callbacks: [handleSwipeEnd],
      events: ['touchend'],
      elements: queryNavigator,
    },
    swipingMove: {
      callbacks: [handleSwipeMove],
      events: ['touchmove'],
      elements: queryNavigator,
    },
    selectCollection: {
      callbacks: [selectActiveTab],
      events: ['click'],
      elements: queryNavigator + ' div li',
    },
  };

  /**
  * @constructs NewHomeSource.GalleryTab
  */
  function GalleryTab() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   * @param {object} data information that was changed.
   */
  GalleryTab.update = function update(data, topic) {
    render(data);
    if (topic === 'onCollectionSet') {
      const selectedCollectionName = data.Name;
      trackerMedia.trackCollectionImpressionEvent(selectedCollectionName);
    }
  };

  /**
   * @public
   * showArrows: calculate limit of CTA and show arrow.
   */
  GalleryTab.showArrows = function showArrows() {
    getRightViewportLimit();
    showLeftAndRightArrow();
  };

  /**
  * @public
  * noConflict: Returns control of NewHomeSource.GalleryTab to the previous script.
  */
  GalleryTab.noConflict = function noConflict() {
    global.NewHomeSource.GalleryTab = previousGalleryTab;
    return GalleryTab;
  };

  global.NewHomeSource.Event(eventsConfiguration);
  global.NewHomeSource.FullImageViewerState.add('onCollectionSet', GalleryTab);
  global.NewHomeSource.FullImageViewerState.add('onResize', GalleryTab);
  global.NewHomeSource.GalleryTab = GalleryTab;
}(window));
